import { useEffect } from 'react';
import { BasicSelectField, InputField } from 'lib/iterable-hook-form/FormField';
import { RateLimitUnit } from 'modules/workflows/constants';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { ErrorText } from 'ui/formField';
import { CHECKBOX_VAL, PERIOD_FIELD, PERMIT_FIELD } from '../CallWebhookEditor.constants';
import { StyledHeader } from '../CallWebhookEditor.styled';
import { CallWebhookEditorFormSchemaType } from '../CallWebhookFormProvider';
import {
  Content,
  Description,
  InputsWrapper,
  RateLimitInputWrapper,
  RateLimitSelectWrapper,
  SeparatorText,
  StyledCheckboxField,
} from './WebhookRateLimit.styled';

const RATE_LIMIT_UNIT_OPTIONS = Object.entries(RateLimitUnit).map(([key, val]) => ({
  id: key,
  value: val,
  label: key?.toLowerCase(),
}));

export const ERROR_TEST_ID = 'rate-limit-error-text';

export const WebhookRateLimit = ({ isReadOnly }: { isReadOnly: boolean }) => {
  const { trigger } = useFormContext();
  const { errors } = useFormState<CallWebhookEditorFormSchemaType>();
  const { nodeData: nodeDataErrors } = errors;

  const [checkboxVal, periodDropdown] = useWatch({
    name: [CHECKBOX_VAL, `nodeData.${PERIOD_FIELD}`],
  });

  useEffect(() => {
    if (checkboxVal) trigger(`nodeData.${PERMIT_FIELD}`);
  }, [checkboxVal, periodDropdown]);

  return (
    <Content>
      <StyledCheckboxField id={CHECKBOX_VAL} name={CHECKBOX_VAL} isDisabled={isReadOnly} />
      <div>
        <StyledHeader>Set a rate limit</StyledHeader>
        <Description>Limit how fast Iterable will call this webhook.</Description>
        {checkboxVal && (
          <>
            <InputsWrapper>
              <RateLimitInputWrapper>
                <InputField
                  isDisabled={isReadOnly}
                  name={`nodeData.${PERMIT_FIELD}`}
                  Suffix="calls"
                  type="number"
                />
              </RateLimitInputWrapper>
              <SeparatorText>per</SeparatorText>
              <RateLimitSelectWrapper>
                <BasicSelectField
                  name={`nodeData.${PERIOD_FIELD}`}
                  options={RATE_LIMIT_UNIT_OPTIONS}
                  isDisabled={isReadOnly}
                  isFullWidth
                />
              </RateLimitSelectWrapper>
            </InputsWrapper>
            {nodeDataErrors?.permit && (
              <ErrorText data-test={ERROR_TEST_ID}>{nodeDataErrors.permit?.message}</ErrorText>
            )}
          </>
        )}
      </div>
    </Content>
  );
};
